/* eslint-disable no-unused-vars */
// -----------------------------------------------------------------------------
// PartnerTab – slimmed down: creators can only set email-forwarding and
// toggle the Auto-emailer.  All Partner/OAuth logic is commented-out.
// -----------------------------------------------------------------------------
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  FormControlLabel,
  Switch,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import TabPanelHidden from "../../../../Components/TabPanelHidden";

/* -------------------------------------------------------------------------- */
/*  >>> GOOGLE-OAUTH (deprecated – kept for future)                           */
/* -------------------------------------------------------------------------- */
/*
import { useGoogleLogin } from "@react-oauth/google";

const GMAIL_SCOPES =
  "https://www.googleapis.com/auth/gmail.modify https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email";

const googleLogin = useGoogleLogin({
  scope: GMAIL_SCOPES,
  flow: "auth-code",
  ux_mode: "redirect",
  redirect_uri: "https://www.useblitz.co/creatorconnect/redirect",
  state: googleRequest,
  onError: (e) => alert("Google connect failed: " + e),
});

useEffect(() => {
  if (userStatus === "Partner" && !refreshToken && googleRequest) googleLogin();
}, [googleRequest, userStatus, refreshToken]);
*/
/* -------------------------------------------------------------------------- */

export default function PartnerTab({
  tabValue,
  index,
  processEmails,
  setProcessEmails,
  forwardedAlias,
  setForwardedAlias,
  onSave,    
}) {
  /* ──────────────────────────  LOCAL STATE  ─────────────────────────── */
  const [aliasInput, setAliasInput] = useState(forwardedAlias || "");
  const [aliasDlgOpen, setAliasDlgOpen] = useState(false);

  useEffect(() => setAliasInput(forwardedAlias || ""), [forwardedAlias]);

  const handleAliasBlur = () => {
    if (aliasInput && aliasInput !== forwardedAlias) setAliasDlgOpen(true);
  };

  const confirmAlias = () => {
    setForwardedAlias(aliasInput.trim());
    onSave?.(aliasInput.trim());          // autosave right away
    setAliasDlgOpen(false);
  };

  /* ─────────────────────────────  RENDER  ───────────────────────────── */
  return (
    <TabPanelHidden value={tabValue} index={index}>
      {/* — development note — */}
      <Alert severity="info" sx={{ mb: 2 }}>
        Direct Gmail linking is paused for now. Please use email forwarding.
      </Alert>

      {/* — Auto-emailer (AI) toggle — */}
      <FormControlLabel
        control={
          <Switch
            checked={processEmails}
            onChange={(e) => setProcessEmails(e.target.checked)}
            color="primary"
          />
        }
        label="Enable Auto-emailer"
        sx={{ mb: 1 }}
      />

      {/* — Forwarding alias input — */}
      <TextField
        label="Your external email (for forwards)"
        type="email"
        fullWidth
        margin="normal"
        value={aliasInput}
        onChange={(e) => setAliasInput(e.target.value)}
        onBlur={handleAliasBlur}
        helperText="We’ll listen for mails forwarded from this address into partnerships@useblitz.co"
      />

      {/* — 3-step guide — */}
      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          3-Step Program to Set Up Email Forwarding
        </Typography>
        <List component="ol" sx={{ pl: 3 }}>
          <ListItem>
            <ListItemText primary="1. Log in to your email and open Settings → Forwarding and POP/IMAP." />
          </ListItem>
          <ListItem>
            <ListItemText primary='2. Click “Add a forwarding address” and enter partnerships@useblitz.co.' />
          </ListItem>
          <ListItem>
            <ListItemText primary="3. Confirm the verification email to complete setup." />
          </ListItem>
        </List>
      </Box>

      {/* — Alias confirmation dialog — */}
      <Dialog open={aliasDlgOpen} onClose={() => setAliasDlgOpen(false)}>
        <DialogTitle>Confirm email forwarding</DialogTitle>
        <DialogContent dividers>
          <Typography>
            I confirm I have enabled <strong>email forwarding</strong> from{" "}
            <strong>{aliasInput || "my email"}</strong> to{" "}
            <strong>partnerships@useblitz.co</strong>.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAliasDlgOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={confirmAlias}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </TabPanelHidden>
  );
}
